module.exports = __webpack_public_path__ + "img/25_1910_kknn.ef175662.jpg";